<template>
    <div class="container">
                <!-- <getarea v-if="Bgetarea" @close="Bgetarea=false"></getarea> -->
        <div class="content">
            <div class="username">{{ReportUserInfoData.uname}}</div>
            <div class="address">体验地点：{{ReportUserInfoData.experience_address}}</div>
            <div class="signIn" :class="[{'notSignIn':!Distance || !signStatus}]" @click="signInClick">
                <div v-if="signStatus">{{Distance?'签到打卡':'无法签到'}}</div>
                <div v-else>
                    <div class="flcenter">
                        <img style="width:40px;height:40px;" src="@/assets/images/user/talk/signok.png" alt="">
                    </div>
                    已签到
                </div>
            </div>
            <div class="time" v-if="Object.keys(ReportUserInfoData).length > 0" :style="{marginBottom:Distance?'56px':'13px'}">
                预约时间：{{ReportUserInfoData.mark_start.substring(0,16)}}~{{ReportUserInfoData.mark_end.substring(11,16)}}
            </div>
            <div v-if="Object.keys(ReportUserInfoData).length > 0">
                <div class="signnot" v-show="ReportUserInfoData.mark_start.substring(0,10) != nowDate && !Distance">
                    仅限预约当天签到
                    {{Distance?'当前离打卡地点太远，无法打卡':''}}
                </div>
                <div class="signnot" v-show="ReportUserInfoData.mark_start.substring(0,10) == nowDate && !Distance">
                    当前离打卡地点太远，无法打卡
                </div>
            </div>
            <div class="map">
                <!-- <el-amap vid="amap" :plugin="plugin"  :center="center" class="amap-demo">
                </el-amap> -->
                <el-amap v-if="center.length > 0" vid="amap" :zoom="zoom" :center="center" class="amap-demo">
                    <!-- 点坐标  -->
                    <el-amap-marker :offset="[-30,-37]" :position="center" :visible="marker.visible" :draggable="marker.draggable" vid="index" :icon="marker.iconImg1"></el-amap-marker>
                    <el-amap-marker :offset="[-30,-37]"  :position="targetArea" :visible="marker2.visible" :draggable="marker2.draggable" vid="index2" :icon="marker2.iconImg2"></el-amap-marker>
                    <!-- 标记文本 -->
                    <!-- <el-amap-info-window
                        :offset="[20,-20]"
                        :position="this.center"
                        :content="content"
                    ></el-amap-info-window>
                    <el-amap-info-window
                        :offset="[20,-20]"
                        :position="this.targetArea"
                        :content="content2"
                    ></el-amap-info-window> -->
                </el-amap>  
            </div>
        </div>
    </div>
</template>



<script>
import {wxGetLocationH5,getWxSingleConfig} from '@/js/wx.js'
// import  getarea from '@/components/getarea/getarea.vue'
import {fetchVerifyAuthForB} from '@/libsV2/havc.js'
export default {
    // components:{
    //     getarea
    // },
    data () {
        return {
            signStatus:true,//签到状态
            center:[],//当前位置
            targetArea:[],//体验间位置
            // label1:{ content: '当前位置', offset: [0,-30] },
            // label2:{ content: '体验间位置', offset: [0,-30] },
            Bgetarea:false,
            // content2:`<div class="textInfoMap" style="background-image:url('~@/assets/images/user/talk/currentArea.png'); width:100%;height:100%;">体验间地址</div>`,
            // content:`<div class="textInfoMap" style="background-image:url('~@/assets/images/user/talk/targetareaText.png'); width:100%;height:100%;">您的位置</div>`,
            plugin: [{
                enableHighAccuracy: true,//是否使用高精度定位，默认:true
                timeout: 100,          //超过10秒后停止定位，默认：无穷大
                maximumAge: 0,           //定位结果缓存0毫秒，默认：0
                convert: true,           //自动偏移坐标，偏移后的坐标为高德坐标，默认：true
                showButton: true,        //显示定位按钮，默认：true
                buttonPosition: 'RB',    //定位按钮停靠位置，默认：'LB'，左下角
                showMarker: true,        //定位成功后在定位到的位置显示点标记，默认：true
                showCircle: true,        //定位成功后用圆圈表示定位精度范围，默认：true
                panToLocation: true,     //定位成功后将定位到的位置作为地图中心点，默认：true
                zoomToAccuracy:true,    //定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：f
                zoomEnable:true,
                extensions:'all',
                pName: 'Geolocation',
            }],
            currentArea:{
                lon: 0,
                lat: 0,
            },
            location: "",
            slotStyle: {
                padding: '2px 8px',
                background: '#eee',
                color: '#333',
                border: '1px solid #aaa'
            },
            zoom: 5,
            marker: {
                visible: true,
                draggable: false,
                template: '<span>2</span>',
                iconImg1:require('@/assets/images/user/talk/targetArea.png'),
            },
            marker2: {
                visible: true,
                draggable: false,
                template: '<span>1</span>',
                iconImg2:require('@/assets/images/user/talk/nowarea.png'),
            },
            texts: [
                {
                    position: this.center,
                    text: '您当前位置',
                    backgroundColor:"#ffa961",
                    offset: [0, -50],
                    visible:true,
                },
                {
                    position: this.targetArea,
                    text: '样板间位置',
                    visible:true,
                    offset: [0, -50],
                },
            ],
        }
    },
    created() {
        let that = this;
        // $init(() => {
            fetchVerifyAuthForB(() => {
                that.getWxSingleConfig().then (() => {
                    this.$nextTick(() => {
                        this.$store.commit("loadSwitch", false);
                    })
                })
            })
        // })
    },
    computed:{
        nowDate () {
            let newDate = new Date();
            const year = newDate.getFullYear();
            let month = newDate.getMonth() + 1;
            let date = newDate.getDate();
            month = (month < 10) ? '0' + month : month
            date = (date < 10) ? '0' + date : date
            return year + '-' + month + '-' + date
        },
        //报告信息，用户信息
        ReportUserInfoData() {
            return this.$store.state.userTalkAppoint.ReportUserInfoData
        },
        Distance() {
            const distance = this.$store.state.userTalkAppoint.distance
            console.log(distance,'distance');
            if (!distance) return false
            if (distance <= 1000) {
                return true
            } else {
                return false
            }
        },
    },
    methods:{
        async getWxSingleConfig(){
            this.$store.commit("loadSwitch", true);
            let id = this.$route.query.id
            await getWxSingleConfig()
            wxGetLocationH5().then (res => {
                console.log(res,'res');
                // const location = res.businessAreas[0].location
                this.currentArea.lat = res.latitude
                this.currentArea.lon = res.longitude
                this.center = [Number(this.currentArea.lon),Number(this.currentArea.lat)]
                // 获取距离
                this.$store.dispatch({type: 'userTalkAppoint/SendCheckSignIn',report_id:id,longitude:this.currentArea.lon,latitude:this.currentArea.lat})
            }).catch (() => {
                // this.Bgetarea = true
                this.$toast({message:'位置获取失败'})
            });
            await this.$store.dispatch({type: 'userTalkAppoint/getReportInfoData',report_id:id}).then(() => {
                console.log(this.ReportUserInfoData,'data');
                this.targetArea = [Number(this.ReportUserInfoData.experience_lon),Number(this.ReportUserInfoData.experience_lat) ]
                this.marker2.visible = true;
                this.$forceUpdate()
            })
            if (navigator.geolocation){//如果getCurrentPosition()运行成功， //则向参数showPosition中规定的函数返回一个coordinates对象
                navigator.geolocation.getCurrentPosition(this.showPosition);
            }else{
                
            }
        },
        showPosition(position){  //showPosition() 函数获得并显示经度和纬度
            this.lat= position.coords.latitude
            this.lon = position.coords.longitude;
        },
        // 点击签到触发的函数
        signInClick () {
            // 只有在距离合适，以及处于可以签到的状态才可以签到
            if (this.Distance && this.signStatus) {
                // this.$store.dispatch({type:'userTalkAppoint/SendSignIn',report_id:this.$route.query.id,longitude:121.586213454,latitude:31.0467065087})
                this.$store.dispatch({type:'userTalkAppoint/SendSignIn',report_id:this.$route.query.id,longitude:this.currentArea.lon,latitude:this.currentArea.lat}).then(() => {
                    this.signStatus = false
                    this.$toast({message:'签到成功'})
                })
            } else if (this.Distance && !this.signStatus) {
                this.$toast({message:'您已签到，请勿重复签到'})
            } else {
                this.$toast({message:'无法签到'})
            }
        }
    }
}
</script>
<style lang='scss' scoped>
::v-deep .amap-icon  img {
    width: 120px;
    height: 96px;
}

// ::v-deep .amap-marker-label {
//     background-color: transparent;
//     border: none;
//     // color: #fff;
//     background-size: 100% 100%;
//     padding: 15px;
//     padding-bottom: 22px;
//     line-height:33px;
// }
// ::v-deep .amap-marker:nth-child(2) div {
//     background-image:url('~@/assets/images/user/talk/targetareaText.png') !important;
// }
// ::v-deep .amap-marker:nth-child(1) div {
//     background-image:url('~@/assets/images/user/talk/currentArea.png') !important;
// }
// ::v-deep .amap-icon img {
//     max-width: 1.4rem !important;
//     max-height: 1.48rem !important;
// }
// ::v-deep .amap-info-content{
//     background:none;
//     background-size: 100% 100%;
//     color: #fff;
//     box-shadow: none;
//     .textInfoMap{
//         margin-top: -10px;
//         padding-left: 12px;
//     }
//     a {
//         display: none;
//     }
// }
// ::v-deep .amap-info-content:nth-child(2) {
// }
// ::v-deep .amap-info-content:nth-child(1) {
//     background-image:url('~@/assets/images/user/talk/targetareaText.png') !important;
// }
//   ::v-deep  .amap-info-sharp{ display: none; }
    .container {
        width: 100%;
        background: #F0F4F1;
        height: 100%;
        padding: 24px;
        position: relative;
        .content {
            background-color: #FFFFFF;
            border-radius: 12px;
            .username {
                padding-top: 38px;
                text-align: center;
                font-size: 32px;
                font-weight: 500;
                color: #444444;
                line-height: 44px;
            }
            .address {
                margin-top:18px;
                text-align: center;
                font-size: 28px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #318544;
                line-height: 36px;
                margin-bottom: 112px;
            }
            .signIn {
                margin:0 auto;
                width: 252px;
                height: 252px;
                display: flex;
                justify-content: center;
                align-items: center;
                background: linear-gradient(90deg, #46B46B 0%, #318544 100%);
                box-shadow: 0px 16px 20px 0px rgba(49,133,68,0.25);
                border-radius: 50%;
                font-size: 40px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #FFFFFF;
            }
            .notSignIn {
                background: linear-gradient(180deg, #FAB860 0%, #F89543 100%);
                box-shadow: 0px 16px 20px 0px rgba(249,161,77,0.3);
            }
            .signInAgain {
                background: #6C9276;
                box-shadow: 0px 8px 10px 0px rgba(108, 146, 118, 0.32);
                display:flex;
                justify-content: center;
                align-items: center;
            }
            .time {
                margin-top: 24px;
                text-align: center;
                font-size: 24px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #858585;
                line-height: 32px;
                margin-bottom: 26px;
            }
            .signnot {
                text-align: center;
                padding-bottom: 50px;
                font-size: 28px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #FFA961;
                line-height: 40px;
            }
            .map {
                width: 654px;
                height: 622px;
                padding: 24px ;
                position: relative;
                .amap-demo {
                    position: absolute;
                    top: -20px;
                    width: 100%;
                    height: 100%;
                    overflow: auto;
                    pointer-events: auto;
                }
                
            }
        }
    }
    .flcenter {
        display:flex;
        justify-content: center;
        align-items:center;
    }
</style>